(function () {
  const forms = document.querySelectorAll('.cert-verify__form');

  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;

      const value = input.value.trim();
      if (!value) {
        event.preventDefault();
        input.focus();
        return;
      }

      input.value = value.toUpperCase();
    });
  });

  document.querySelectorAll('[data-cert-verify-print]').forEach((button) => {
    button.addEventListener('click', () => {
      window.print();
    });
  });
})();
